<template>
  <div>
    <overview-result></overview-result>
  </div>
</template>

<script>
import OverviewResult from "@/views/home/components/OverviewResult";
export default {
  components: {
    OverviewResult,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.component {
  .el-tabs__item {
    font-size: 20px;
  }
}

.info-component {
  margin-top: 24px;
}

@media only screen and (max-width: 1200px) {
  .component {
    .el-tabs__item {
      font-size: 18px;
    }
  }
}

.noborder {
  border: 0;
}

.chart-container {
  height: 530px;
}

.item-container {
  height: 265px;
}
</style>
